import { booleanFormatter } from "../../formatters/booleanFormatter";
import CloseRedIconSvg from "../../svg/CloseRedIconSvg";
import { editSvg } from "../../svg/edit.svg";
import { editOffSvg } from "../../svg/editOff.svg";

const ListCardAddNewGift = ({
  item,
  editingRowId,
  handleEditClick,
  DeleteStoreItem,
  setEditingRowId,
  setAddGift,
}) => {
  return (
    <div
      className="card shadow-sm mb-3 p-3"
      style={{
        border: "1px solid #eee",
        borderRadius: "10px",
        direction: "rtl",
        backgroundColor: "#f9f9f9",
      }}
    >
      <div className="d-flex justify-content-center">
        <img src={item.Picture} width={80} alt="gift" />
      </div>
      <div className="mb-1 mt-3">
        <strong>نام:</strong> {item.Name}
      </div>
      <hr />
      <div className="mb-1">
        <strong>سکه:</strong> {item.Price}
      </div>
      <div className="mb-1">
        <strong>تعداد دفعات خرید:</strong> {item.PurchaseCount}
      </div>
      <div className="mb-1">
        <strong>نت:</strong> {item.Note}
      </div>
      <div className="d-flex mb-1">
        <strong>وضعیت:</strong> {booleanFormatter(item.IsActive)}
      </div>
      <div className="text-truncate mb-1">
        <strong>توضیحات:</strong> {item.Description}
      </div>
      <hr />
      <div className="d-flex justify-content-between">
        {editingRowId === item.Id ? (
          <div
            onClick={() => {
              setEditingRowId(undefined);
              setAddGift({
                Description: "",
                IsActive: true,
                Name: "",
                Note: "",
                Picture: "",
                Price: "",
              });
            }}
            style={{ cursor: "pointer" }}
          >
            {editOffSvg()}
          </div>
        ) : (
          <div
            onClick={() => handleEditClick(item)}
            style={{ cursor: "pointer" }}
          >
            {editSvg({ width: 15 })}
          </div>
        )}
        <div
          onClick={() => {
            DeleteStoreItem(item.Id).then(() => window.location.reload());
          }}
          style={{ cursor: "pointer" }}
        >
          <CloseRedIconSvg style={{ width: "20px", height: "20px" }} />
        </div>
      </div>
    </div>
  );
};

export default ListCardAddNewGift;
